import axios from "axios";
import { IP } from "./config";
// 查询用户账号
export async function selectspuser() {
  var resp = await axios.post(`${IP}/sup/selectAll`, {});
  return resp.data.data;
}

//开通账号
export async function addspuser(form) {
  var resp = await axios.post(`${IP}/sup/add`, {
    role_id: form.role_id,
    userId: form.userId,
    sup_username: form.sup_username,
    sup_password: form.sup_password,
    supplier_phone: form.supplier_phone,
    message: form.message,
    storeId: form.storeId,
  });
  return resp;
}

//修改账号
export async function updatespuser(form) {
  var resp = await axios.post(`${IP}/sup/update`, {
    id: form.id,
    userId: form.userId,
    role_id: form.role_id,
    sup_username: form.sup_username,
    sup_password: form.sup_password,
    supplier_phone: form.supplier_phone,
    message: form.message,
    storeId: form.storeId,
  });
  return resp;
}

// 删除用户
export async function deletespuser(id) {
  var resp = await axios.post(`${IP}/sup/delete`, {
    id,
  });
  return resp;
}
